import _Menu from "@material-ui/core/esm/Menu";
import _IconButton from "@material-ui/core/esm/IconButton";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import giveawayDotsIcon from 'assets/img/icons/giveaway-dots-icon.svg';
import classes from './vertical-icon-menu.scss';
const DEFAULT_ANCHOR_POSITION = {
  top: 0,
  left: 0
};
export class VerticalIconMenu extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      anchorEl: null
    });
    _defineProperty(this, "handleClick", event => {
      this.setState({
        anchorEl: event.currentTarget
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        anchorEl: null
      });
    });
  }
  render() {
    const {
      anchorEl
    } = this.state;
    const {
      children,
      buttonClassName,
      className,
      wideDots = false,
      anchorOrigin
    } = this.props;
    const menuItems = children.map((child, index) => /*#__PURE__*/React.createElement("div", {
      key: index,
      onClick: this.handleClose
    }, child));
    const otherMenuProps = anchorOrigin ? _objectSpread({}, anchorOrigin) : _objectSpread({}, DEFAULT_ANCHOR_POSITION);
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(className, classes.menuControl),
      "data-menu": "ThreeDots",
      id: "tutorialProductMenu"
    }, /*#__PURE__*/React.createElement(_IconButton, {
      className: classnames(classes.menuButton, buttonClassName),
      onClick: this.handleClick
    }, wideDots ? /*#__PURE__*/React.createElement("img", {
      className: classes.wideDotsIcon,
      src: giveawayDotsIcon,
      alt: "dots-menu"
    }) : /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(_Menu, _extends({
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClose: this.handleClose
    }, otherMenuProps), /*#__PURE__*/React.createElement("div", {
      id: "tutorialDistribute"
    }, menuItems.slice(0, 3)), menuItems.slice(3)));
  }
}